/** Finance screen: external sources (Stripe, PayPal, WooCommerce), revenue summary, operations. */
export const external = {
  'finance.title': 'Фінанси',
  'finance.hint': 'Лише читання: спостереження зі Stripe, PayPal і WooCommerce плюс витрати на ШІ з прогонів агентів.',
  'finance.filter.allBusinesses': 'Усі бізнеси',
  'finance.filter.months3': 'Останні 3 місяці',
  'finance.filter.months6': 'Останні 6 місяців',
  'finance.filter.months12': 'Останні 12 місяців',
  'finance.filter.period': 'Період',
  'finance.kpi.revenue': 'Дохід, {month}',
  'finance.kpi.refunds': 'Повернення',
  'finance.kpi.fees': 'Комісії',
  'finance.kpi.aiCost': 'Витрати на ШІ',
  'finance.chart.title': 'Дохід за місяцями',
  'finance.chart.empty': 'Ще немає спостережень за цей період.',
  'finance.chart.mixedCurrency': 'Бізнеси показані у власних валютах; без конвертації.',

  'finance.sources': 'Джерела',
  'finance.sources.col.source': 'Джерело',
  'finance.sources.col.business': 'Бізнес',
  'finance.sources.col.key': 'Ключ',
  'finance.sources.col.lastSync': 'Остання синхронізація',
  'finance.sources.col.state': 'Стан',
  'finance.sources.sync': 'Синхронізувати',
  'finance.sources.queued': 'У черзі',
  'finance.sources.disable': 'Вимкнути',
  'finance.sources.enable': 'Увімкнути',
  'finance.sources.never': 'ще не було',
  'finance.sources.state.ok': 'ок · {n} записів',
  'finance.sources.state.error': 'помилка · спроба {n}',
  'finance.sources.state.retry': 'наступна спроба {at}',
  'finance.sources.state.disabled': 'вимкнено',
  'finance.sources.state.partial': 'триває · {n} записів',
  'finance.sources.state.new': 'ще не синхронізовано',
  'finance.sources.add': '+ Підключити джерело',
  'finance.sources.form.title': 'Нове джерело',
  'finance.sources.form.business': 'Бізнес',
  'finance.sources.form.kind': 'Сервіс',
  'finance.sources.form.name': 'Назва',
  'finance.sources.form.credential': 'Ключ (лише для читання)',
  'finance.sources.form.noCredential': 'Немає ключа для цього сервісу. Додай його в «Команда → Ключі й доступи».',
  'finance.sources.form.baseUrl': 'Адреса магазину (https://…)',
  'finance.sources.form.sandbox': 'Пісочниця PayPal',
  'finance.sources.form.startDate': 'Читати з дати (необов’язково)',
  'finance.sources.form.secretHint.stripe': 'Ключ Stripe: обмежений ключ із доступом на читання до charges і refunds.',
  'finance.sources.form.secretHint.paypal': 'Ключ PayPal: секрет у форматі «client_id:client_secret».',
  'finance.sources.form.secretHint.woocommerce': 'Ключ WooCommerce: секрет у форматі «consumer_key:consumer_secret», права Read.',
  'finance.sources.form.submit': 'Підключити',

  'finance.ops': 'Операції',
  'finance.ops.col.when': 'Коли',
  'finance.ops.col.business': 'Бізнес',
  'finance.ops.col.source': 'Джерело',
  'finance.ops.col.kind': 'Тип',
  'finance.ops.col.amount': 'Сума',
  'finance.ops.col.externalId': 'Зовнішній ID',
  'finance.ops.kind.payment': 'платіж',
  'finance.ops.kind.refund': 'повернення',
  'finance.ops.kind.fee': 'комісія',
  'finance.ops.filter.allKinds': 'Усі типи',
  'finance.ops.more': 'Показати ще',
  'finance.ops.total': 'Усього: {n}',
  'finance.noAccess': 'Немає доступу до фінансів.',
} as const;
